import React, { Suspense, useMemo } from "react";
import { useGLTF } from "@react-three/drei";

const ThreeA = (props) => {
  // GLTF
  const gltf = useGLTF("./three-1.glb");
  const copiedScene = useMemo(() => gltf.scene.clone(), [gltf.scene]);

  return (
    <Suspense fallback={null}>
      <primitive {...props} object={copiedScene} />
    </Suspense>
  );
};

useGLTF.preload("./three-1.glb");

export default ThreeA;
